import { createContext, useContext, useState } from 'react';

const WikiSearchContext = createContext();

export const useWikiSearch = () => {
  const context = useContext(WikiSearchContext);
  if (!context) {
    return { searchTerm: '', setSearchTerm: () => {} };
  }
  return context;
};

export const WikiSearchProvider = ({ children }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [currentMatchIndex, setCurrentMatchIndex] = useState(0);
  const [totalMatches, setTotalMatches] = useState(0);

  return (
    <WikiSearchContext.Provider
      value={{
        searchTerm,
        setSearchTerm,
        currentMatchIndex,
        setCurrentMatchIndex,
        totalMatches,
        setTotalMatches,
      }}
    >
      {children}
    </WikiSearchContext.Provider>
  );
};
